import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";

// Section Components
import HeroSection from "./HeroSection";
import GivingBackSection from "./GivingBackSection";
import StrategySection from "./StrategySection";
import MissionSection from "./MissionSection";
import Footer from "../../components/common/Footer";
import TestimonialPage from "./TestimonialsSection";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>
          About Utpann | Sustainable Organic Agriculture Solutions & Bio-Gas
          Innovation
        </title>
        <meta
          name="description"
          content="Learn about Utpann's mission to promote organic farming through fermented organic manure and bio-gas production."
        />
      </Helmet>

      <main className="w-full bg-background-main overflow-hidden">
        {/* <div className="w-full mt-[46px]">
     
        </div> */}

        <HeroSection />
        <GivingBackSection />
        <StrategySection />
        <MissionSection />
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default AboutPage;
